export enum GroupNames {
	Administrator = 'administrator',
	Negocio = 'negocio',
	AO = 'ao',
	AdministradorToken = 'w_apl_mcareadminportal_admin',
	NegocioToken = 'w_apl_mcareadminportal_busin',
	AOToken = 'w_apl_mcareadminportal_tkmng',
}
